// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__Ggic0","text":"SelectPayment_text__2YHCY","title":"SelectPayment_title__2M1CE","btn":"SelectPayment_btn__2BTam"};